module.exports = __webpack_public_path__ + "img/discovery_hover.7f270117.png";